var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-139d6289-8db4-4665-94d2-a1263eb4359b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-c3c0de78-b11d-423a-ab1d-abaf3232aff0 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c3c0de78-b11d-423a-ab1d-abaf3232aff0",
    d: "M20.21,8.98h-5.99c-.82,0-1.48.67-1.48,1.48v.66h-.19c-1.37,0-2.48,1.11-2.48,2.48v6.88c0,1.37,1.11,2.48,2.48,2.48h4.4c1.37,0,2.48-1.11,2.48-2.48v-.18h.79c.82,0,1.48-.67,1.48-1.48v-8.37c0-.82-.67-1.48-1.48-1.48ZM17.42,20.49c0,.26-.22.48-.48.48h-4.4c-.27,0-.48-.22-.48-.48v-6.88c0-.27.22-.48.48-.48h4.4c.26,0,.48.22.48.48v6.88ZM19.42,18.82v-5.21c0-1.37-1.11-2.48-2.48-2.48h-2.72v-.65s5.97-.02,5.97-.02l.02,8.35h-.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.11ab7ef1262979dcb54da7e816a8dc8c.svg";
export { ForwardRef as ReactComponent };